import React, { useContext } from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import { LoadingContext } from '../context/LoadingContext';


export default function Income() {
  const [loading, setLoading] = useContext(LoadingContext)
    return (
        <>
                <div className="layout-container">
                    <Menu />
                    <div className="layout-page">
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <div>
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text">Performance Reward</p>
                                                            <div className="d-flex align-items-end mb-2">
                                                                <h4 className="card-title mb-0 me-2">58,352 USD</h4>
                                                            </div>
                                                        </div>
                                                        <div className="card-icon">
                                                            <span className="badge bg-label-success rounded p-2">
                                                                <i className="bx bx-user bx-sm" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text">Passive Unilevel Reward</p>
                                                            <div className="d-flex align-items-end mb-2">
                                                                <h4 className="card-title mb-0 me-2">58,352 USD</h4>
                                                            </div>
                                                        </div>
                                                        <div className="card-icon">
                                                            <span className="badge bg-label-success rounded p-2">
                                                                <i className="bx bx-user bx-sm" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text">Top Referral Reward</p>
                                                            <div className="d-flex align-items-end mb-2">
                                                                <h4 className="card-title mb-0 me-2">58,352</h4>
                                                            </div>
                                                        </div>
                                                        <div className="card-icon">
                                                            <span className="badge bg-label-success rounded p-2">
                                                                <i className="bx bx-user bx-sm" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text">Vip Unilevle Reward</p>
                                                            <div className="d-flex align-items-end mb-2">
                                                                <h4 className="card-title mb-0 me-2">58,352</h4>
                                                            </div>
                                                        </div>
                                                        <div className="card-icon">
                                                            <span className="badge bg-label-success rounded p-2">
                                                                <i className="bx bx-user bx-sm" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text">Royalty</p>
                                                            <div className="d-flex align-items-end mb-2">
                                                                <h4 className="card-title mb-0 me-2">58,352 USD</h4>
                                                            </div>
                                                        </div>
                                                        <div className="card-icon">
                                                            <span className="badge bg-label-success rounded p-2">
                                                                <i className="bx bx-user bx-sm" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text">Royalty Award</p>
                                                            <div className="d-flex align-items-end mb-2">
                                                                <h4 className="card-title mb-0 me-2">58,352 USD</h4>
                                                            </div>
                                                        </div>
                                                        <div className="card-icon">
                                                            <span className="badge bg-label-success rounded p-2">
                                                                <i className="bx bx-user bx-sm" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="card">
                                            <h5 className="card-header">Award/Reward Information</h5>
                                            <div className="card-datatable table-responsive">
                                                <table className="datatable table border-top ">
                                                    <thead>
                                                        <tr>
                                                        </tr><tr>
                                                            <th className="text-uppercase text-primary text-xxs font-weight-bolder ">Type of Award/ Reward</th>
                                                            <th className="text-uppercase text-primary text-xxs font-weight-bolder">Level</th>
                                                            <th className="text-uppercase text-primary text-xxs font-weight-bolder">Refrence</th>
                                                            <th className="text-uppercase text-primary text-xxs font-weight-bolder">On Total</th>
                                                            <th className="text-uppercase text-primary text-xxs font-weight-bolder">Per</th>
                                                            <th className="text-uppercase text-primary text-xxs font-weight-bolder">Reward</th>
                                                            <th className="text-uppercase text-primary text-xxs font-weight-bolder">Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
        </>
    );
}
